import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';
const SplitDialog = props => {
    const { leftContent, rightContent, onClose, leftContentClassName, rightContentClassName, className } = props, remainingProps = __rest(props, ["leftContent", "rightContent", "onClose", "leftContentClassName", "rightContentClassName", "className"]);
    const dialogClassName = `split-dialog ${className}`;
    const dividerClasses = classNames('split-divider', 'bg-lighter');
    const body = (_jsxs("div", Object.assign({ className: 'split-wrapper' }, { children: [_jsxs("div", Object.assign({ className: `split-left ${leftContentClassName}` }, { children: [leftContent, _jsx("div", { className: dividerClasses })] })), _jsx("div", Object.assign({ className: `split-right ${rightContentClassName}` }, { children: rightContent }))] })));
    return _jsx(Dialog, Object.assign({}, remainingProps, { body: body, onHide: onClose, className: dialogClassName }));
};
SplitDialog.defaultProps = {
    className: '',
    footer: '',
    useOverflow: true,
    showCloseButton: true,
    leftContentClassName: '',
    rightContentClassName: '',
};
SplitDialog.propTypes = Object.assign(Object.assign({}, baseDialogPropTypes), { leftContent: PropTypes.node, leftContentClassName: PropTypes.string, rightContent: PropTypes.node, rightContentClassName: PropTypes.string, bodyClassName: PropTypes.string, footerClassName: PropTypes.string, footer: PropTypes.node });
export default SplitDialog;
